import requestAxios from "@/helpers/request_axios";
import generateUUID from "@/helpers/generate_uuid";
import * as MutationsType from "./mutationsType";

function findUnlinkedSteps(steps) {
  const stepMap = new Map(steps.map((step) => [step.id, step]));
  const visited = new Set();
  const mainStep = steps.find((step) => step.main);
  if (!mainStep) return [];

  const traverse = (stepId) => {
    if (visited.has(stepId)) return;
    visited.add(stepId);
    const step = stepMap.get(stepId);
    if (!step) return;

    if (step.next_step_id) {
      traverse(step.next_step_id);
    }

    if (!step.options) return;
    step.options.forEach((opt) => {
      if (opt.next_step_id) traverse(opt.next_step_id);
    });
  };

  traverse(mainStep.id);
  return steps.filter((step) => !visited.has(step.id));
}

export default {
  addUserResponseMock({ commit, state }, { parentOptionInd = null, parentStepId = null }) {
    let replyOption = "";
    let replyContent = "";

    if (parentOptionInd !== null) {
      const nextStepIndex = state.assistantSteps.findIndex((step) => step.id === parentStepId);
      replyContent = state.assistantSteps[nextStepIndex].content;
      replyOption = state.assistantSteps[nextStepIndex].options[parentOptionInd].title;
    }

    if (parentStepId && parentOptionInd === null) {
      const nextStepIndex = state.assistantSteps.findIndex((step) => step.id === parentStepId);
      replyContent = state.assistantSteps[nextStepIndex].content;
    }

    const userResponse = {
      id: generateUUID(),
      title: "",
      content: replyContent,
      reply: replyOption,
      type: "text",
      role: "user",
      weight: 0,
      options: [],
      triggers: [],
      preTriggers: [],
      isVisible: true,
    };

    commit(MutationsType.ADD_STEP, userResponse);
  },
  addOrUpdateStep({ commit, state, dispatch }, { parentOptionId = null, parentOptionInd = null, parentStepId = null }) {
    let nextStepIndex = -1;

    if (parentOptionInd !== null) {
      let parent = state.assistantSteps.findIndex((step) => step.id === parentStepId);
      let option = state.assistantSteps[parent].options[parentOptionInd];
      if (option.next_step_id)
        nextStepIndex = state.assistantSteps.findIndex((step) => step.id === option.next_step_id);
    }
    if (parentStepId && parentOptionInd === null) {
      let parent = state.assistantSteps.find((step) => step.id === parentStepId);
      if (parent.next_step_id)
        nextStepIndex = state.assistantSteps.findIndex((step) => step.id === parent.next_step_id);
    }

    dispatch("addUserResponseMock", { parentOptionId, parentStepId, parentOptionInd });

    if (nextStepIndex === -1) {
      const newStep = {
        id: generateUUID(),
        title: "",
        content: "Contenido del nuevo paso",
        type: "text",
        role: "assistant",
        weight: 0,
        isVisible: true,
        options: [],
        keywords: [],
        triggers: [],
        pre_triggers: [],
      };

      commit(MutationsType.ADD_STEP, newStep);
      commit(MutationsType.SET_CURRENT_STEP_INDEX, state.assistantSteps.length - 1);
      commit(MutationsType.UPDATE_STEP, { updates: { id: parentStepId } });

      if (parentOptionInd !== null) {
        const parentStep = state.assistantSteps.find((step) => step.id === parentStepId);
        let options = parentStep.options;
        options[parentOptionInd].next_step_id = newStep.id;
        commit(MutationsType.UPDATE_STEP, { updates: { id: parentStepId, options } });
      } else if (parentStepId && parentOptionInd === null) {
        commit(MutationsType.UPDATE_STEP, { updates: { id: parentStepId, next_step_id: newStep.id } });
      }
    } else {
      const existingStep = state.assistantSteps[nextStepIndex];

      commit(MutationsType.ADD_STEP, { ...existingStep, isVisible: true });
      commit(MutationsType.SET_CURRENT_STEP_INDEX, state.assistantSteps.length - 1);
    }
  },
  updateStep({ commit }, step) {
    commit(MutationsType.UPDATE_STEP, { updates: step });
  },
  addOptionToStep({ commit, state }, option) {
    commit(MutationsType.ADD_OPTION_TO_STEP, { stepIndex: state.currentStepIndex, option });
  },
  updateOptionToStep({ commit, state }, optionIndex) {
    commit(MutationsType.UPDATE_OPTION_TO_STEP, { stepIndex: state.currentStepIndex, optionIndex });
  },
  setCurrentStepIndex({ commit }, index) {
    commit(MutationsType.SET_CURRENT_STEP_INDEX, index);
  },
  selectOption({ commit, state }, { optionId }) {
    commit(MutationsType.SELECT_OPTION, { stepIndex: state.currentStepIndex, optionId });
  },
  removeOptionFromStep({ commit, state }, optionId) {
    commit(MutationsType.REMOVE_OPTION_FROM_STEP, { stepIndex: state.currentStepIndex, optionId });
  },
  addTriggerToStepOption({ commit, state }, { optionId }) {
    commit(MutationsType.ADD_TRIGGER_TO_STEP_OPTION, { stepIndex: state.currentStepIndex, optionId });
  },
  removeTriggerFromStepOption({ commit, state }, { optionId, triggerInd }) {
    commit(MutationsType.REMOVE_TRIGGER_FROM_STEP_OPTION, { stepIndex: state.currentStepIndex, optionId, triggerInd });
  },
  resetAllSteps({ commit, dispatch }) {
    commit(MutationsType.RESET_ASSISTANT);
    dispatch("fetchAssistantSteps");
  },
  async fetchAssistantSteps({ commit, rootState }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v2/channels/assistants/${rootState.Agent.agent.business_id}/versions/default/steps`,
        method: "GET",
      });
      let data = response.data.data;
      let steps = data.steps || [];
      if (steps.length === 0) {
        steps = [
          {
            id: generateUUID(),
            role: "assistant",
            title: "Hola, bienvenido",
            content: "Por favor seleccione una de las opciones para poder ayudarte",
            type: "actions",
            main: true,
            weight: 0,
            options: [
              {
                id: generateUUID(),
                title: "Ver catálogo",
                hidden: false,
              },
              {
                id: generateUUID(),
                title: "Contactar con asesor",
                hidden: false,
              },
            ],
            triggers: [],
            preTriggers: [],
          },
        ];
      }
      steps = steps.map((step) => ({
        ...step,
        isVisible: step.main,
        goal: step.goal || "Ninguno",
        keywords: step.keywords || [],
        triggers: step.triggers || [],
        pre_triggers: step.pre_triggers || [],
      }));
      const stepsSorted = steps.sort((a, b) => {
        // Si 'a' es el principal, viene antes que 'b'
        if (a.main && !b.main) {
          return -1;
        }
        // Si 'b' es el principal, viene antes que 'a'
        else if (!a.main && b.main) {
          return 1;
        }

        // Si ambos tienen 'parent_step_ids' vacíos o ambos no vacíos, comparamos por 'weight'
        return a.weight - b.weight;
      });

      commit(MutationsType.LOAD_STEPS, stepsSorted);
    } catch (error) {
      throw error.response.data;
    }
  },
  linkToExistingStep({ commit, state }, { selectedStepId, parentOptionId = null, parentStepId = null }) {
    // Encuentra el paso actual basado en `parentStepId` o el último paso si `parentStepId` es nulo
    let currentStepIndex = parentStepId
      ? state.assistantSteps.findIndex((step) => step.id === parentStepId)
      : state.currentStepIndex;
    let currentStep = state.assistantSteps[currentStepIndex];

    // Encuentra el paso seleccionado basado en `selectedStepId`
    let selectedStepIndex = state.assistantSteps.findIndex((step) => step.id === selectedStepId);
    let selectedStep = state.assistantSteps[selectedStepIndex];

    if (selectedStep) {
      // Actualiza los parent_step_ids y parent_option_ids del paso seleccionado
      if (currentStep) {
        selectedStep.parent_step_ids = Array.from(new Set([...selectedStep.parent_step_ids, currentStep.id]));
        if (parentOptionId) {
          selectedStep.parent_option_ids = Array.from(new Set([...selectedStep.parent_option_ids, parentOptionId]));
        }
      }

      // Commit la actualización del paso seleccionado
      commit(MutationsType.UPDATE_STEP, { updates: selectedStep });

      // Opcionalmente, puede actualizar el estado para reflejar el paso seleccionado como el actual
      // commit(MutationsType.SET_CURRENT_STEP_INDEX, selectedStepIndex);
      commit(MutationsType.ADD_STEP, { ...selectedStep, isVisible: true });
      commit(MutationsType.SET_CURRENT_STEP_INDEX, state.assistantSteps.length - 1);
    }
  },
  linkToExistingStep2({ commit, state }, { selectedStepId, parentOptionId = null, parentStepId = null }) {
    const selectedStep = state.assistantSteps.find((step) => step.id === selectedStepId);
    const parentStep = state.assistantSteps.find((step) => step.id === parentStepId);
    if (!parentStep) return;

    if (parentOptionId) {
      const optionInd = parentStep.options.findIndex((option) => option.id === parentOptionId);
      parentStep.options[optionInd].next_step_id = selectedStepId;
      delete parentStep.next_step_id;
      commit(MutationsType.UPDATE_STEP, { updates: parentStep });
    } else {
      commit(MutationsType.UPDATE_STEP, { updates: { ...parentStep, next_step_id: selectedStepId } });
    }

    // Opcionalmente, puede actualizar el estado para reflejar el paso seleccionado como el actual
    // commit(MutationsType.SET_CURRENT_STEP_INDEX, selectedStepIndex);
    commit(MutationsType.ADD_STEP, { ...selectedStep, isVisible: true });
    commit(MutationsType.SET_CURRENT_STEP_INDEX, state.assistantSteps.length - 1);
  },
  unlinkPreviousStep({ commit, state }, { prevStepId }) {
    // Encuentra el índice del paso previamente vinculado
    const prevStepIndex = state.assistantSteps.findIndex((step) => step.id === prevStepId);
    if (prevStepIndex >= 0) {
      commit(MutationsType.UPDATE_STEP_ALL_ATRIBUTES, {
        updates: { ...state.assistantSteps[prevStepIndex], isVisible: false },
      });
    }
  },
  async deleteSteps({ state, commit }) {
    try {
      const unlinkedSteps = findUnlinkedSteps([...state.assistantSteps]);

      const stepsDeleted = unlinkedSteps.map((step) => step.id);

      let response = await requestAxios({
        url: "/awy/api/v2/channels/assistants/steps",
        method: "DELETE",
        data: { steps: stepsDeleted },
      });

      stepsDeleted.forEach((stepId) => {
        commit(MutationsType.DELETE_STEP, { id: stepId });
      });

      return response.data.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  async saveAllSteps({ state, rootState }, { isDraft = false }) {
    try {
      const stepsUniqueById = {};

      // Elimina los steps sin ninguna relacion
      // await dispatch("deleteSteps");
      const unlinkedSteps = findUnlinkedSteps([...state.assistantSteps]);

      const stepsDeleted = unlinkedSteps.map((step) => step.id);

      state.assistantSteps.forEach((step) => {
        if (stepsDeleted.includes(step.id)) {
          return;
        }
        // if (step.role === "assistant") {
        /// main = true es el menu principal y no tiene parent_step_ids ni parent_option_ids
        // if (step.parent_step_ids.length > 0 || step.main) {
        stepsUniqueById[step.id] = {
          id: step.id,
          title: step.title,
          type: step.type,
          content: step.content,
          weight: step.weight,
          // parent_step_ids: step.parent_step_ids,
          // parent_option_ids: step.parent_option_ids,
          main: step.main || false,
          role: step.role,
          file_id: step.file_id,
          schema: step.schema,
          options: step.options,
          goal: step.goal,
          keywords: step.keywords,
          next_step_id: step.next_step_id,
          triggers: step.triggers,
          pre_triggers: step.pre_triggers,
        };
        // }
        // }
      });

      // Ahora `stepsUniqueById` contiene solo pasos únicos.
      // Convierte esto de nuevo a un array si necesitas un array para la operación de guardado.
      const uniqueStepsArray = Object.values(stepsUniqueById);
      let allSteps = uniqueStepsArray.map((step) => {
        if (step.type === "form") {
          if (!step.schema) {
            throw new Error(`The step: ${step.title} \n${step.content} does not have a schema attribute`);
          }
          let newFormat = {};
          step.schema.forEach((s) => {
            newFormat[s.id] = {
              type: s.type,
              description: s.label,
            };
          });
          step.schema = newFormat;
        }

        if (step.type === "calendar") {
          step.schema = {
            appointment_date_time: {
              type: "string",
              description: "Fecha y hora (agenda evento)",
            },
          };
        }

        if (step.type !== "actions") {
          step.options = [];
        }
        if (step.type !== "form") {
          delete step.schema;
        }
        return step;
      });

      let route = `/awy/api/v2/channels/assistants/${rootState.Agent.agent.business_id}${
        isDraft ? "/versions/default/steps" : "/deploy"
      }`;

      let response = await requestAxios({
        url: route,
        method: "POST",
        data: { steps: allSteps },
      });
      return response.data.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // eslint-disable-next-line
  async unlinkAssistantStep({}, { stepId }) {
    await requestAxios({
      url: `/awy/api/v2/channels/assistants/steps/${stepId}`,
      method: "POST",
      data: { step_id: stepId },
    });
  },
  resetModuleChannelWhatsApp({ commit }) {
    commit(MutationsType.RESET_ASSISTANT);
  },
};
